class EmailValidator {
	message = 'Поле должно содержать значение вида: mail@box.ru';

	validate = (value: string) => {
		const regexp = /^(.+)@(.+)\.(.+)+$/i;
		return regexp.test(value);
	};
}

export default EmailValidator;
